import classNames from 'classnames';
import { type ComponentPropsWithoutRef, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import styles from '../tree-skeleton.module.css';
import layoutStyles from './variable-length-skeleton.module.css';

const SKELETON_WIDTHS = ['30%', '70%', '50%', '90%', '40%', '80%'];
const SKELETON_HEIGHT = '16px';
type VariableLengthSkeletonProps = {
  count: number;
  fade?: boolean;
  delay?: number;
  skeletonWidths?: string[];
  skeletonHeight?: string;
  checkboxes?: boolean;
} & ComponentPropsWithoutRef<'div'>;

export const VariableLengthSkeleton = ({
  count = 1,
  fade,
  delay = 0,
  skeletonWidths = SKELETON_WIDTHS,
  skeletonHeight: _skeletonHeight = SKELETON_HEIGHT,
  checkboxes,
  className,
  ...restProps
}: VariableLengthSkeletonProps) => {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSkeleton(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return showSkeleton ? (
    <div
      className={classNames(
        styles.themedSkeletons,
        fade && styles.fade,
        className
      )}
      {...restProps}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div className={layoutStyles.skeletonRow} key={index}>
          {checkboxes && (
            <Skeleton height={SKELETON_HEIGHT} width={SKELETON_HEIGHT} />
          )}
          <div
            className={layoutStyles.skeletonBar}
            data-with-checkbox={checkboxes || undefined}
          >
            <Skeleton
              width={skeletonWidths[index % skeletonWidths.length]}
              height={SKELETON_HEIGHT}
            />
          </div>
        </div>
      ))}
    </div>
  ) : null;
};
